import { inject, Injectable, signal, WritableSignal } from "@angular/core";
import {
    AssociatedTenantUserDto,
    AssociateTenantUserRequest,
    CompleteResetPasswordForUserTenantRequest,
    GetAssociatedTenantUsersByResetTokenRequest,
    UserRoleAssociationType,
    UserServiceProxy,
} from "@shared/api/service-proxies";
import { NotifyService } from "@ui/notify";
import { Observable } from "rxjs";

@Injectable()
export class TenancySelectService {
    _notify = inject(NotifyService);
    _userApi = inject(UserServiceProxy);

    associatedTenants: WritableSignal<AssociatedTenantUserDto[]> = signal([]);

    tenantsToAssociate: WritableSignal<AssociatedTenantUserDto[]> = signal([]);

    loading: WritableSignal<boolean> = signal(false);

    constructor() {}

    getAssociatedTenants(): Observable<AssociatedTenantUserDto[]> {
        const NonPatientUserRoleAssociationType = UserRoleAssociationType._1;
        return this._userApi.getAssociatedTenants(NonPatientUserRoleAssociationType);
    }

    processAssociatedTenants(tenants: AssociatedTenantUserDto[]): void {
        this.associatedTenants.set([]);
        this.tenantsToAssociate.set([]);
        for (const tenant of tenants) {
            tenant.isAssociated
                ? this.associatedTenants.update((prev) => [...prev, tenant])
                : this.tenantsToAssociate.update((prev) => [...prev, tenant]);
        }
    }
    associateTenantUser(userId: number, password: string): Observable<boolean> {
        let request = AssociateTenantUserRequest.fromJS({ userId, password });
        return this._userApi.associateTenantUser(request);
    }

    completeResetPasswordForAssociatedUsers(
        userId: number,
        tenantId: number,
        password: string,
        token: string
    ): Observable<void> {
        let request = CompleteResetPasswordForUserTenantRequest.fromJS({ userId, tenantId, password, token });
        return this._userApi.completeResetPasswordForAssociatedUsers(request);
    }

    getAssociatedTenantsByResetToken(token: string): Observable<AssociatedTenantUserDto[]> {
        let request = GetAssociatedTenantUsersByResetTokenRequest.fromJS({ token });
        return this._userApi.getAssociatedTenantsByResetToken(request);
    }
}
